/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
import Rules, { ValidateRule } from '@mcfe/tools-rules';
import { getUuid } from '@mcfe/tools';
import { VERSION_SOURCE } from '../list/constants';

// ---资质信息---
// 其他照片附件
export const LICENSE_OTHER_TYPE = 0;
// 必填资质类型
export const REQUIRED_LICENSE_TYPE = {
    BUSINESS_LICENSE: 1, // 营业执照
    PRODUCTION_LICENSE: 6, // 生产许可证
};
// 必填资质类型list
export const needLicenseList = [
    { licenseType: REQUIRED_LICENSE_TYPE.BUSINESS_LICENSE, name: '营业执照' },
    { licenseType: REQUIRED_LICENSE_TYPE.PRODUCTION_LICENSE, name: '生产许可证' },
];
// 是否长期有效
export const LICENSE_TYPE = {
    YES: 1,
    NO: 0,
};
export const isLongTermOptions = [
    { label: '是', value: LICENSE_TYPE.YES },
    { label: '否', value: LICENSE_TYPE.NO },
];
export const defaultLicenseItem = () => ({
    name: '', // 资质名称
    licenseType: null, // 资质类型
    isLongTerm: LICENSE_TYPE.NO, // 资质是否长期
    dateRange: [], // 证件有效期
    imageList: [], // 资质图片
    uuId: getUuid(),
});


// ---实物图片---
// 实物图片类型枚举
export const PRODUCT_PIC_TYPE = {
    PRODUCT_PIC_CONTENTS: 1, // 内容物产品图片（未包装）- V1版必填项
    MIN_RETAIL_PACKAGE_PIC: 2, // 最小零售包装（正反两面）- V1版选填项
    OUTER_BOX_PIC: 3, // 外箱照片（整体照片）- V1版选填项
};
// 实物图片类型描述label名
export const PRODUCT_PIC_TYPE_MAP = {
    [PRODUCT_PIC_TYPE.PRODUCT_PIC_CONTENTS]: '内容物产品图片（未包装）',
    [PRODUCT_PIC_TYPE.MIN_RETAIL_PACKAGE_PIC]: '最小零售包装（正反两面）',
    [PRODUCT_PIC_TYPE.OUTER_BOX_PIC]: '外箱照片（整体照片）',
};
// 默认实物图片配置
export const defaultEntityPicData = () => [
    { type: PRODUCT_PIC_TYPE.PRODUCT_PIC_CONTENTS, file: [] },
    { type: PRODUCT_PIC_TYPE.MIN_RETAIL_PACKAGE_PIC, file: [] },
    { type: PRODUCT_PIC_TYPE.OUTER_BOX_PIC, file: [] },
];


// ---标签信息---
// 标签信息类型枚举
export const LABEL_TYPE = {
    INNER_PACKAGE_LABEL: 1, // 内包装标签
    OUTER_BOX_LABEL: 2, // 外箱标签- V1版选填项
};
// 标签信息类型类型label名
export const LABEL_TYPE_MAP = {
    [LABEL_TYPE.INNER_PACKAGE_LABEL]: '内包装标签',
    [LABEL_TYPE.OUTER_BOX_LABEL]: '外箱标签',
};
// 默认标签信息配置
export const defaultLabelData = () => [
    { type: LABEL_TYPE.INNER_PACKAGE_LABEL, file: [] },
    { type: LABEL_TYPE.OUTER_BOX_LABEL, file: [] },
];

// ---包装材质---
export const defaultPackageDataItem = () => ({
    content: '', // 包装物内容
    item: '', // 包装物明细
    form: '', // 包装形式
    size: {
        sizeLength: '',
        sizeWidth: '',
        sizeHeight: '',
    }, // 规格尺寸（mm)
    level: '', // 材料等级
    weightCapacity: '', // 成品承重/摆放层高
    standard: '', // 执行标准
    supplierInfo: '', // 包材供应商信息
    uuId: getUuid(),
});

// ---配料信息---
export const irradiationOptions = [
    { label: '是', value: true },
    { label: '否', value: false },
];
export const defaultMixDataItem = () => ({
    name: '', // 配料名称
    component: '', // 复合配料组成
    actualRate: '', // 实际投料质量占比
    lastRate: '', // 终产品质量占比
    label: [], // 原料标签
    irradiation: null, // 是否经过辐照
    production: '', // 配料生产商
    address: '', // 配料生产商地址
    other: '', // 原料等级/产地要求
    uuId: getUuid(),
});

// ---工艺流程图---
// 默认工艺流程描述配置
export const logOptions = [
    { label: '是', value: true },
    { label: '否', value: false },
];
export const defaultTechnologyProcessDataItem = () => ({
    process: '', // 生产过程（按实际填写）
    metric: '', // 关键技术指标
    range: '', // 标准值/受控范围
    model: '', // 设备型号
    time: '', // 工艺时间
    rate: '', // 抽样数量/监控频率
    log: true, // 是否记录
    uuId: getUuid(),
});

export const defaultCheckDataItem = () => ({
    type: null, // 项目类型
    name: '', // 检测项目名称
    rate: '', // 检测频次
    mark: '', // 备注
    uuId: getUuid(),
});

// ---车辆运输---
// 运输要求
const TRANSPORT_REQUIREMENTS = {
    vehicleInspection: '车辆运输要求一：产品装车运输前，需对运输车辆的卫生进行检查；须注明摆放层高（箱体无标识的由厂家提供包装箱的称重，建议层高）；',
    temperatureControl: '车辆运输要求二：生产商要求标准：车辆运输温度按照冷冻、冷藏、常温分温层；卫生要求：运输工具应清洁、干燥',
};
// 获取默认运输要求列表
export const defaultTransportData = () => [TRANSPORT_REQUIREMENTS.vehicleInspection, TRANSPORT_REQUIREMENTS.temperatureControl];
// 是否为两条默认运输要求
export const isDefaultTransportData = (requirement, index) => defaultTransportData().includes(requirement) && index <= 1;

// ---产品质量标准---
// 感官要求
export const defaultSensoryRequirementsItem = () => ({
    name: '',
    describe: '',
    method: '',
    brokenPackage: '',
    mark: '',
    image: [],
    handle: 1, // 整批拒收
    uuId: getUuid(),
});
export const initSensoryRequirementsName = '净含量';
// 感官要求-净含量项目
export const initSensoryRequirements = () => ({
    ...defaultSensoryRequirementsItem(),
    name: initSensoryRequirementsName, // 项目名称
});

// 始发需要豁免营养成分表检测
export const exemptionOptions = [
    { label: '豁免营养成分表检测', value: true },
    { label: '无需豁免营养成分表检测', value: false },
];
// 添加营养成分表
export const defaultNutritionDetailItem = () => ({
    nutrition: '', // 营养成分
    end: null, // 检测结果（每100g/mL）
    nrv: null, // NRV（影响素参考值）
    uuId: getUuid(),
});
// 营养成分表初始默认项
// 默认「能量」「蛋白质」「脂肪」「碳水化合物」和「钠」5种营养成分类型；
export const nutritionList = [
    '能量',
    '蛋白质',
    '脂肪',
    '碳水化合物',
    '钠',
];
export const defaultNutritionDataDetail = (value) => {
    if (value) {
        return {
            ...defaultNutritionDetailItem(),
            nutrition: value,
        };
    }

    return nutritionList.map((nutrition) => ({
        ...defaultNutritionDetailItem(),
        nutrition,
    }));
};

// 供应商暂存3。 供应商保存4
export const SUPPLIER_SAVE_TYPE = {
    TEMP_SAVE: 3,
    SAVE: 4,
};

export const initDetail = () => ({
    skuBaseInfo: {
        skuId: null,
        skuName: null,
        storageTemperatureLevel: null,
        guaranteePeriodMap: [],
        category3Name: null,
        category4Name: null,
        preSkuId: null,
        preSkuName: null,
        leafBgCategoryId: null,
        supplierId: null,
        producerId: null,
        organizationId: null,
        organizationPath: null,
        pactContent: null,
        competitorSkuName: null,
        competitorSkuId: null,
        storageTemperatureLevelStr: null,
        organizationMis: null,
    },
    purchaseEditData: {
        barcode: null,
        productClaim: null,
        productClaimIds: [],
        irradiation: null,
        compareBarcode: null,
    },
    // 品控芥末填写内容回显
    qualityEditData: {
        qualityEditAcceptanceStandard: [],
        samplingMethod: null,
    },
    supplierEditData: {
        certData: [],
        entityPicData: [],
        labelData: [],
        packageData: [],
        mixData: [],
        technologyProcessData: {
            technologyProcessDataInfo: {
                files: [],
                filesDesc: '', // 工艺流程图描述
            },
            technologyProcessDescribeDatas: [],
        },
        checkData: [],
        transportData: [],
        productQualityStandard: {
            sensoryRequirements: [],
            nutritionData: {
                exemption: null,
                exemptionReason: null,
                detail: [],
            },
        },
        otherData: [],
        // 基本信息生产商信息输入
        supplierBaseData: {
            producerContactPerson: null,
            producerContactPhone: null,
        },
    },
    approvalResponse: {
        standardState: null,
        purchaseState: null,
        qcState: null,
        supplierState: null,
        supplierLabelState: null,
        supplierOtherState: null,
        purchaseReasonList: [],
        // 供应商标签+营养成分表审核驳回原因
        supplierLabelReasonList: [],
        // 供应商其他审核驳回原因
        supplierOtherReasonList: [],
    },
    // 供应商允许修改
    // supplierUpdateState: null, // TODO暂时后端不维护了，按状态判断就行
    standardVersion: null,
    supplierExtendData: {
        supplierName: null,
        supplierAddress: null,
        supplierContactPerson: null,
        supplierContactPhone: null,
        producerName: null,
        producerAddress: null,
    },
    exportButton: null,
});

export const rules = {
    supplierBaseData: {
        producerContactPerson: [
            Rules.isRequired('生产商联系人必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        producerContactPhone: [
            Rules.isRequired('生产商联系方式必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
        ],
    },
    // 资质认证情况
    qualificationRule: {
        certData: [
            Rules.isRequired({ validArray: true }, '资质认证情况不能为空'),
        ],
        name: [
            Rules.isRequired('请输入资质名称'),
        ],
        licenseType: [
            Rules.isRequired('请选择资质类型'),
        ],
        isLongTerm: [
            Rules.isRequired('请选择是否长期有效'),
        ],
        imageList: [
            Rules.isRequired({
                validArray: true,
                trigger: 'blur',
            }, '请上传资质'),
        ],
    },
    // 成品及包装信息
    productPackageRule: {
        // 实物图片
        entityPicData: [
            Rules.isRequired({ validArray: true }, '实物图片不能为空'),
        ],

        // 标签信息
        labelData: [
            Rules.isRequired({ validArray: true }, '标签信息不能为空'),
        ],

        // 包装材质
        packageData: [
            Rules.isRequired({ validArray: true }, '包装材质不能为空'),
        ],
        content: [
            Rules.isRequired('包装物内容必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        item: [
            Rules.isRequired('包装物明细必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        form: [
            Rules.isRequired('包装形式必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        size: [
            Rules.isRequired('规格尺寸（mm）必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        sizeLength: [
            Rules.isRequired('长必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.range({ min: 0, le: false }, '请填写大于0的数字'),
        ],
        sizeWidth: [
            Rules.isRequired('宽必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.range({ min: 0, le: false }, '请填写大于0的数字'),
        ],
        sizeHeight: [
            Rules.isRequired('高必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.range({ min: 0, le: false }, '请填写大于0的数字'),
        ],
        level: [
            Rules.isRequired('材料等级必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        weightCapacity: [
            Rules.isRequired('成品承重/摆放层高必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        standard: [
            Rules.isRequired('执行标准必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        supplierInfo: [
            Rules.isRequired('包材供应商信息必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],

        // 配料信息
        mixData: [
            Rules.isRequired({ validArray: true }, '配料信息不能为空'),
        ],
        name: [
            Rules.isRequired('配料名字必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        component: [
            Rules.isRequired('复合配料组成必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        actualRate: [
            Rules.isRequired('实际投料质量占比%必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.range({ min: 0, le: false, max: 100 }, '请填写 0-100 的数字'),
            Rules.decimalLen({ len: 10 }, '最多保留10位小数'),
        ],
        lastRate: [
            // 终产品质量占比%
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.range({ min: 0, le: false, max: 100 }, '请填写 0-100 的数字'),
            Rules.decimalLen({ len: 10 }, '最多保留10位小数'),
        ],
        label: [
            Rules.isRequired({ validArray: true }, '原料标签必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        irradiation: [
            Rules.isRequired('请选择是否经过辐照'),
        ],
        production: [
            Rules.isRequired('配料生产商必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        address: [
            Rules.isRequired('配料生产商地址必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        other: [
            Rules.isRequired('原料等级/产地要求必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
    },
    // 工艺流程图
    technologyProcessDataRule: {
        files: [
            Rules.isRequired({ validArray: true }, '请上传工艺流程图'),
            new ValidateRule({
                validator(rule, value, callback) {
                    if (!value || !value.length) {
                        callback('请至少上传一张图片格式文件');
                        return;
                    }
                    // 检查数组中是否包含图片文件
                    const hasImage = value.some((file) => /\.(jpg|jpeg|png)$/i.test(file || ''));
                    if (!hasImage) {
                        callback('请至少上传一张jpg、jpeg、png格式文件');
                    }
                    callback();
                },
            }),
        ],
        filesDesc: [
            Rules.isRequired('请输入工艺流程图描述'),
            Rules.lenRange({ max: 10000 }, '最多10000个字符'),
        ],
        technologyProcessDescribeDatas: [
            Rules.isRequired({ validArray: true }, '请至少填写一条工艺流程图描述'),
        ],
        process: [
            Rules.isRequired('生产过程（按实际填写）必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        metric: [
            Rules.isRequired('关键技术指标必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        range: [
            Rules.isRequired('标准值/受控范围必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        model: [
            Rules.isRequired('设备型号必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        time: [
            Rules.isRequired('工艺时间必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        rate: [
            Rules.isRequired('抽样数量/监控频率必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        log: [
            Rules.isRequired('请选择是否记录'),
        ],
    },

    // 出厂检验及型式检验项目
    checkDataRule: {
        checkData: [
            Rules.isRequired({ validArray: true }, '出厂检验及型式检验项目不能为空'),
        ],
        type: [
            Rules.isRequired('项目类型必选'),
        ],
        name: [
            Rules.isRequired('检测项目名称必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        rate: [
            Rules.isRequired('检测频次必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        mark: [
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
    },

    // 产品质量标准
    // 感官要求
    sensoryRequirementsRule: {
        sensoryRequirements: [
            Rules.isRequired({ validArray: true }, '感官要求不能为空'),
        ],
        name: [
            Rules.isRequired('项目名称必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        describe: [
            Rules.isRequired('指标描述必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        method: [
            Rules.isRequired('检测方法必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        brokenPackage: [
            Rules.isRequired('检测方法（破包）必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        mark: [
            Rules.isRequired('不合格描述必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        image: [
            Rules.isRequired({ validArray: true }, '不合格图片必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        handle: [
            Rules.isRequired('不合格处置必填'),
        ],
    },
    // 营养成分表
    nutritionDataRule: {
        exemption: [
            Rules.isRequired('必选是否需要豁免营养成分表检测'),
        ],
        exemptionReason: [
            Rules.isRequired('豁免理由必填'),
            Rules.lenRange({ min: 1, max: 500 }, '请填写500字以内的豁免理由'),
        ],
        nutritionDataDetail: [
            Rules.isRequired({ validArray: true }, '营养成分表不能为空'),
        ],
        nutrition: [
            Rules.isRequired('营养成分必填'),
            Rules.lenRange({ max: 500 }, '最多500个字符'),
        ],
        end: [
            Rules.isRequired('检测结果（每100g/mL）必填'),
            Rules.typeValid({ type: 'number' }, '请填写数字'),
            Rules.decimalLen({ len: 2 }, '最多保留两位小数'),
        ],
        nrv: [
            Rules.isRequired('NRV（影响素参考值）%必填'),
            Rules.typeValid({ type: 'integer' }, '请输入整数'),
        ],
    },
};

// 实物图片-内容物产品图片（未包装）-V1必填
export const getProductPicContents = (version) => {
    if (version !== VERSION_SOURCE.V1) return [];
    return [
        Rules.isRequired({
            trigger: 'blur',
            validArray: true,
            message: '请上传内容物产品图片（未包装）',
        }),
    ];
};

// 实物图片-最小零售包装（正反两面）-V1版非必填
export const getMinRetailPackagePicRules = (version) => {
    if (version !== VERSION_SOURCE.V2) return [];
    return [
        Rules.isRequired({
            trigger: 'blur',
            validArray: true,
            message: '请上传最小零售包装（正反两面）',
        }),
    ];
};
// 实物图片-外箱照片（整体照片）-V1版非必填
export const getOuterBoxPicRules = (version) => {
    if (version !== VERSION_SOURCE.V2) return [];
    return [
        Rules.isRequired({
            trigger: 'blur',
            validArray: true,
            message: '请上传外箱照片（整体照片）',
        }),
    ];
};

// 标签信息-内包装标签-V1版必填
export const getInnerPackageLabelRules = (version) => {
    if (version !== VERSION_SOURCE.V1) return [];
    return [
        Rules.isRequired({
            trigger: 'blur',
            validArray: true,
            message: '请上传内包装标签',
        }),
    ];
};

// 标签信息-外箱标签-V1版非必填
export const getOuterBoxLabelRules = (version) => {
    if (version !== VERSION_SOURCE.V2) return [];
    return [
        Rules.isRequired({
            trigger: 'blur',
            validArray: true,
            message: '请上传外箱标签',
        }),
    ];
};

// 资质-证件有效期规则校验
export const getDateRangeRules = () => [
    Rules.isRequired({ validArray: true }, '请选择证件有效期'),
    new ValidateRule({
        validator(rule, value, callback, row) {
            const today = +(new Date().setHours(23, 59, 59, 999));
            if (!value?.[0] || !value?.[1]) return callback('请选择证件有效期');
            if (value && value.length === 2 && value.every((v) => !!v)) {
                const [beginTime, endTime] = value;
                if (endTime && +endTime < today) {
                    callback('该资质过期');
                }
            }
            callback();
        },
    }),
];

// 图片类型与URL
const PICTURE_URL_MAP = {
    entityPicData: {
        // 实物图片-内容物产品图片（未包装）
        [PRODUCT_PIC_TYPE.PRODUCT_PIC_CONTENTS]: [
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/7f7fc7b8630fb96efb9d3295fbe1e09692868.png',
        ],
        // 实物图片-最小零售包装（正反两面）
        [PRODUCT_PIC_TYPE.MIN_RETAIL_PACKAGE_PIC]: [
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/ae733cfdfd93d25937b0cc5ac37705df86153.png',
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/ba6d17c25b38d5fa8eb2ce063e8024ae92741.png',
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/887e8aa283f9280fef079beea3b7372916009.png',
        ],
        // 实物图片-外箱照片（整体照片）
        [PRODUCT_PIC_TYPE.OUTER_BOX_PIC]: [
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/5bf32cd65a49b88fb9712c0e75f5b89230258.png',
            'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/7f0bbbd74ee97e2f2627756603ed334b35655.png',
        ],
    },
    labelData: {
        // 标签信息-内包装标签
        [LABEL_TYPE.INNER_PACKAGE_LABEL]: ['https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/b6b449637f1e9a281211d99ea4c33d8638519.png'],
        // 标签信息-外箱标签
        [LABEL_TYPE.OUTER_BOX_LABEL]: ['https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/fad61123b7dab31f77e9de443bebb04922437.png'],
    },
    mixData: {
        filesWaterTemplate: ['https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/35d56ac1e4a94297fd64f5c89530297d2972028.png'],
    },
    technologyProcessData: {
        filesTemplate: ['https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/0a98c31426fd8156b2fd9de68dca67ae151885.png'],
    },
};
// 获取示例图片URL
export const getExamplePic = (type, fields) => {
    if (!type || !fields) {
        return '';
    }
    return PICTURE_URL_MAP[fields]?.[type] || '';
};

const TIPS_CONFIG = {
    entityPicData: {
        [PRODUCT_PIC_TYPE.PRODUCT_PIC_CONTENTS]: [
            '1、请上传不同角度的图片，如：横切面图片、正反两面图、主视图、俯视图、左视图等；',
            '2、请如实拍摄，不要商详页上的宣传图片，生产商需要补充商品内容物图片；',
        ],
        [PRODUCT_PIC_TYPE.MIN_RETAIL_PACKAGE_PIC]: [
            '1、请上传独立包装后的正/反面图片；',
            '2、如装盒的，需要提供放入盒子内的状态图片；',
            '3、如果袋体&盒体有特殊标准的，如激光对齐、透明袋子商有串码等需要做详细描述',
        ],
        [PRODUCT_PIC_TYPE.OUTER_BOX_PIC]: [
            '1、如果是周转箱，请同步装箱后的状态图；',
            '2、如果是纸箱，请同步装在箱子内部的图片，以及封箱图片，如箱体正面和侧面；',
        ],
    },
    labelData: {
        [LABEL_TYPE.INNER_PACKAGE_LABEL]: [
            '1、上传的图片清晰，拉伸不变形；上传的图片需要体现：商品配料表、营养成分表、生产商、保质期、存储条件、执行标准的界面；',
            '2、允许上传：商品中文字内容的设计稿本（标签文字内容需与待上市终产品一致即可）',
            '3、允许上传：已经确认的文字内容（采购确认版）',
        ],
        [LABEL_TYPE.OUTER_BOX_LABEL]: [
            '1、外箱粘贴的标签，如果是美团周转筐，无标签可明示；如果纸箱有标签则需要上传；',
        ],
    },
    packageData: [
        '1、请在下方填写所有与食品直接接触的包装材料，不得使用回收材料；',
        '2、成品限高，限重，如箱体无标识，填写内部管控指标',
    ],
    mixData: [
        '1、请在下方填写实际配料信息，按添加量从高到低填写；',
        '2、同一个配料由多个生产商提供时，在输入框中输入多个生产商，不同生产商间用逗号隔开；',
        '3、复合配料的组成：复合配料在此处展开填写，如果是自制原料，需要写明占比%；',
        '4、配料单独有：水、生活饮用水；系统无需单独上传原料标签图例；其它农产品、配料内容均需正常填写；',
        '5、其它加工用水（如RO过滤水，天然矿泉水等上传过滤水设备在原料标签处均可）；',
        '6、特殊产品：如终产品即为：天然矿物质水、纯净水、生活饮用水等以水为主的产品；直接下拉键增加过滤设备图例；',

        '7、添加剂：（防腐剂、抗氧化剂、着色剂、甜味剂、漂白剂、酸度调节剂、抗结剂、消泡剂、膨松剂、护色剂、乳化剂、酶制剂、增味剂、面粉处理剂、被膜剂、水分保持剂、稳定和凝固剂、增稠剂、食品用香料、食品加工助剂、胶基糖果中基础剂物质等）；同一功能的食品添加剂(相同色泽着色剂、防腐剂、抗氧化剂)在混合使用时,各自用使用量占其最大使用量的比例之和不应超过1。',
        '8、原料供应商均在合格供方名录中；原料到货满足原辅料验收标准 饮用水：满足  GB 5749《生活饮用水》',
        '9、配料与标签中配料信息一致；',
    ],
    technologyProcessData: [
        '1、详细描述工艺流程图上的产品生产加工过程细节描述；',
        '2、原料验收&储存的要求温度、半成品使用效期、产品湿度、产品大小、规格内容；',
        '3、原料预处理（含粉料过筛、去除外包装、紫外杀菌等）',
        '4、配料（按配方配置、添加剂满足2760、记录、用量及原料批号）',
        '5、搅拌：含设备型号、参数设置如搅拌时间、速度、添加顺序，搅拌后的状态等',
        '6、金检参数、设备型号及灵敏度',
        '7、杀菌：如杀菌参数、温度、时间、设备型号及杀菌方式；',
        '8、入库储存发货等',
    ],
    sensoryRequirements: [
        '1、按照产品执行标准，风险监控项目，填写全部内容，表格可根据实际检测项目增减；',
        '2、感官要求的指标描述：描述成品的感官指标标准（标准要求及企业标准的成品检查为主）如：组织、形态、色泽、滋味与口感、杂质、净含量等；',
        '3、不合格描述（需附感官不合格参考照片）：满足感官要求的描述颜色上、下限图片；',
    ],
    exemption: [
        '1、请在下方选择是否需要豁免营养成分表检测；',
    ],
    nutrition: [
        '1、营养成分表：宣称内容必须体现如明确营养宣称、营养成分含量声明内容；按照产品执行标准，风险监控项目，填写全部内容，表格可根据实际检测项目增减；',
    ],
    files: [
        '1、请在下方上传工艺流程图（至少上传一张图片格式文件）',
    ],
    checkData: [
        '1、型检报告产品名称与实物一致，注明品牌，如调整配料需重新送三方检测',
        '2、出厂检测项目（同时明确检测频次）：出厂检验的项目包括但不限于感官要求、水分、净含量和馅料含量，每批产品应按GB/T 19855的出厂项目进行检验后方可出厂。',
        '3、型检项目（同时明确检测频次）：每年对产品进行一次型式检验,，按照执行标准全检，并且含每年国抽、GB 2760、GB 2762、GB 29921等中所含项目',
        '4、首次送货，需提供带品牌的型检报告',
    ],
};
// 获取温馨提示信息
export const getTips = (fields, item = { type: '' }) => {
    if (!fields && !item.type) {
        return [];
    }
    const tipsConfig = TIPS_CONFIG[fields];
    return item.type
        ? tipsConfig?.[item.type] || []
        : tipsConfig || [];
};
